<div class="h-full relative overflow-auto">
  @if(isActiveView === 'about'){
  <div>
    <p class="text-xl text-[#53565B] font-semibold">
      <span class="text-k-blue font-bold"> {{ title }} </span>
      Explained
    </p>
  </div>

  <div class="w-full h-[365px] p-1 bg-slate-400 my-6 relative">
    <!-- <div class=""> -->
    <iframe
      src="https://www.loom.com/embed/4b104f21dbac4bdbaf0c0997deefb36e?sid=a798c2fb-a400-48c0-99d3-98c3db18dd27"
      frameborder="0"
      webkitallowfullscreen
      mozallowfullscreen
      allowfullscreen
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
    ></iframe>
    <!-- </div> -->
  </div>
  <div class="h-fit w-full">
    @for(details of setupInstructions; track $index){

    <div class="py-4 px-6 border mb-3 w-full h-fit border-[#DCDCDC] rounded">
      <div class="w-full flex gap-6 h-fit">
        <div class="w-full">
          <p class="font-bold text-lg">
            {{ details.title }}
          </p>
          <ul class="list-disc ml-4">
            @for (item of details?.list; track $index) {
            <li class="my-1 text-[#515765] leading-7">
              <div [innerHTML]="item"></div>
            </li>
            }
          </ul>
        </div>
      </div>
    </div>
    }
  </div>
  }@else {

  <div>
    <p class="text-xl text-[#53565B] font-semibold mb-2">
      {{ (currentUser?.nick_name ?? currentUser?.first_name) + "'s" | titlecase }}
      <span class="text-k-blue font-bold"> {{ title }} </span>
    </p>
    <p class="text-[#53565B] text-sm">
      To learn more about premium keys,
      <a target="_blank" href="https://help.kinnect.us/content/about-premium-keys" class="text-[#487AF0] font-bold"> visit our help center.</a>
    </p>
    <app-add-premium-key-dialog [currentUser]="currentUser"></app-add-premium-key-dialog>
  </div>
  }
</div>
